import React from 'react';
import PropTypes from 'prop-types';

const FixedCard = ({ type, content, value }) => (
    <div data-test = 'scenarioCatalogueFixedCardComponent'>
        <div className="card">
            <div className="card-header"
                style={ type === "passenger" ?
                { backgroundColor: "#757AF7", color: "white", fontSize: "21px"}
                : {backgroundColor: "#8FD800", color: "#622AD8",  fontSize: "21px" }}
            >
                {content}
            </div>
            <div className="card-body" style={{ textAlign: "center" }}>
                <div style={{ fontWeight: "900" }}>{value.toString().padStart(6, '0')}</div>
            </div>
        </div>
    </div>
)
FixedCard.propTypes={
value:PropTypes.string,
content:PropTypes.string,
type:PropTypes.string,

}
FixedCard.defaultProps= {
value:[],
content:[],
type:[],
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }

export default FixedCard
